module.exports = __webpack_public_path__ + "img/poweredby.ebdc94d6.png";